import ChipSelect from "designSystem/components/chip/ChipSelect";
import { CheckedMenuItem } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { useCompareStore } from "csi/page/ComparePageStore";
import { ATTR_PHASE_REVISIONS } from "csi/reflection/reflectionConstants";
import React, { FunctionComponent } from "react";

interface ChipSelectPhaseProps {
	/** flag to indicate compare menu */
	isCompareMenu: boolean;

	/** callback for revision selection */
	onSelectRevision: (item: string, isCompareMenu: boolean) => void;
}

export const ChipSelectPhase: FunctionComponent<ChipSelectPhaseProps> = (props) => {
	const {
		compareNode,
		compareRevisionNode,
		compareProductNode,
		comparePhaseNodes,
		currentNode,
		currentRevisionNode,
		currentProductNode,
		currentPhaseNodes,
		readonlyMode,
	} = useCompareStore();

	const {
		isCompareMenu,
		onSelectRevision,
	} = props;

	let revisionNode = currentRevisionNode;
	let productNode = currentProductNode;
	let bomNode = currentNode;
	let phaseNodes = currentPhaseNodes;

	if (isCompareMenu) {
		revisionNode = compareRevisionNode;
		productNode = compareProductNode;
		bomNode = compareNode;
		phaseNodes = comparePhaseNodes;
	}

	if (!phaseNodes) {
		return null;
	}

	const phaseUrls = phaseNodes.map((node) => node.$URL);
	const phaseRevisions = bomNode[ATTR_PHASE_REVISIONS];
	const currentPhaseNode = phaseNodes[phaseUrls.indexOf(revisionNode.Phase)];

	const loc = useLocale();

	return (
		<ChipSelect buttonText={loc.getNodeName(currentPhaseNode)} disabled={readonlyMode}>
			{
				phaseNodes.map((phaseNode, i) => {
					const phaseNodeName = loc.getNodeName(phaseNode);
					const phaseRevisionUrl = phaseRevisions[phaseNode.$Name];
					return (
						<CheckedMenuItem
							checked={phaseRevisionUrl === revisionNode.$URL}
							disabled={!phaseRevisionUrl}
							key={i}
							onClick={() => onSelectRevision(phaseRevisionUrl, isCompareMenu)}
							text={phaseNodeName}
						/>
					);
				})
			}
		</ChipSelect>
	);
};

export default ChipSelectPhase;